<ag-grid-angular
    #agGrid
    twf-table
    class="ag-theme-alpine"
    [gridOptions]="gridOptions"
    [rowData]="rowData"
    [columnDefs]="columnDefs"
    [frameworkComponents]="frameworkComponents"
    [rowSelection]="rowSelection"
    [style.height]="height"
    [style.display]="showGrid ? 'block' : 'none'"
    [overlayNoRowsTemplate]="overlayNoRowsTemplate | translate"
    (gridReady)="onGridReady($event)"
    (filterChanged)="onFilterChanged($event)"
    (columnMoved)="onColumnMoved($event)"
    (rowClicked)="onRowClicked($event)"
    [enableCellTextSelection]="true">
</ag-grid-angular>
